"use strict";

define('view/empty.table',['underscore', 'marionette', 'uikit/collections/container', 'uikit/mixins/component.mixin', '../templates'], function (_, Mn, Container, ComponentMixin, Templates) {
  var EmptyTableRow = Mn.ItemView.extend(ComponentMixin).extend({
    tagName: 'tr',
    className: 'empty',
    template: Templates.IRB['empty.table'],
    options: {
      icon: 'frown',
      headerTag: 'div',
      text: '',
      opacity: 0.5,
      loading: false,
      loadingSize: '',
      visible: true
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.once('before:render', this.onBeforeFirstRender, this);
      $(this.el).attr({
        'tabindex': '0',
        'aria-label': this.options.text,
        'role': 'region'
      });
    },
    onBeforeFirstRender: function onBeforeFirstRender() {
      var table = this._parent;
      if (table && table.collection) {
        table.collection.on('sync', function () {
          this.visible = true;
        }, this);
        this.visible = !!table.collection.fetched || !_.result(table.collection, 'url');
      }
    },
    onBeforeRender: function onBeforeRender() {
      var table = this._parent;
      if (table && table.columns) {
        this.options.colspan = table.columns.length;
      }
    }
  });
  var EmptyTable = Container.extend({
    attributes: {
      style: 'height: inherit; width: 100%; display: table;'
    },
    initialize: function initialize(emptyViewOptions) {
      Container.prototype.initialize.apply(this, arguments);
      this.add(this.row = new EmptyTableRow(this.options));
    },
    onRender: function onRender() {
      this.$el.css({});
    }
  });
  var LoadingView = EmptyTable.extend({
    options: _.extend({}, EmptyTable.prototype.options, {
      loading: true,
      loadingSize: 'large',
      text: 'Loading'
    })
  });
  EmptyTable.Row = EmptyTableRow;
  EmptyTable.Loading = LoadingView;
  return EmptyTable;
});

